import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';
import type { TextDecoration } from '../types/TextDecoration';

export function composeTextDecorationClasses(decoration: Adaptive<TextDecoration>): string {
    if (typeof decoration === 'object') {
        return clsx(
            decoration.base && decoration.base,
            decoration.sm && `sm:${decoration.sm}`,
            decoration.md && `md:${decoration.md}`,
            decoration.lg && `lg:${decoration.lg}`,
            decoration.xl && `xl:${decoration.xl}`,
            decoration['2xl'] && `2xl:${decoration['2xl']}`
        );
    }

    return decoration;
}
